import styles from './FinishContent.module.scss'

import React from 'react'
import PropTypes from 'prop-types'
import ContactForm from './ContactForm'

class FinishContent extends React.Component {
  render () {
    const { price, answers, onSubmitSuccessful } = this.props

    return (
      <div className={styles.wrapper}>
        <h1>
          O seu site
          <br />
          custaria aproximadamente
        </h1>

        <span className={styles.price}>{price}€*</span>

        <span className={styles.callout}>Quer um orçamento mais preciso?</span>

        <p className={styles.explainer}>
          Na{' '}
          <a href="https://moscadigital.pt">
            <strong>Mosca Digital</strong>
          </a>
          <nobr> desenvolvemos o seu site</nobr> <nobr>com as mais recentes</nobr>
          <nobr> práticas e tecnologias,</nobr> <nobr>de forma a ter</nobr>
          <nobr> o seu site</nobr> pronto <nobr>no mais curto</nobr>
          <nobr> tempo possível</nobr> <nobr>e com a melhor relação</nobr>
          <nobr> qualidade preço.</nobr>
          <br />
          <br />
          Entre em contacto connosco para saber mais.
        </p>

        <ContactForm price={price} answers={answers} onSubmitSuccessful={onSubmitSuccessful} />

        <p className={styles.asteriskText}>
          * Este valor é apenas uma aproximação feita com base em todos os orçamentos efectuados
          pela{' '}
          <a href="https://moscadigital.pt">
            <nobr>Mosca Digital</nobr>
          </a>
          .
        </p>
      </div>
    )
  }
}

FinishContent.propTypes = {
  price: PropTypes.number.isRequired,
  answers: PropTypes.arrayOf(PropTypes.number).isRequired,
  onResetPress: PropTypes.func.isRequired,
  onSubmitSuccessful: PropTypes.func.isRequired,
}

export default FinishContent
